import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { OrderEndpoints } from '../../services/orderService';

export const fetchOrders = createAsyncThunk(
  'orders/fetchOrders',
  async (_, { rejectWithValue }) => {
    try {
      const data = await OrderEndpoints.fetchListOfOrdersAdmin();
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || 'Something went wrong');
    }
  }
);

export const searchAndFilterOrdersAdmin = createAsyncThunk(
  'orders/searchAndFilterOrders',
  async ({ search_term, order_status, payment_status }, { rejectWithValue }) => {
    try {
      // Prepare the request payload
      const payload = {
        search_term: search_term || '',
        order_status: order_status || [],
        payment_status: payment_status || []
      };

      const data = await OrderEndpoints.searchAndFilterOrders(payload);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || 'Something went wrong');
    }
  }
);

export const fetchOrderDetails = createAsyncThunk(
  'orders/fetchOrderDetails',
  async (orderUid, { rejectWithValue }) => {
    try {
      const data = await OrderEndpoints.fetchSingleOrderDetailAdmin(orderUid);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || 'Something went wrong');
    }
  }
);

export const updateOrderStatusAdmin = createAsyncThunk(
  'orders/updateOrderStatus',
  async ({ orderUid, newStatus }, { rejectWithValue }) => {
    try {
      const data = await OrderEndpoints.updateOrderStatus(orderUid, { status: newStatus });
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || 'Something went wrong');
    }
  }
);



export const deleteOrdersAdmin = createAsyncThunk(
  'orders/deleteOrdersAdmin',
  async (orderUids, { rejectWithValue }) => {
    try {
      const response = await OrderEndpoints.deleteOrderAdmin(orderUids);
      return response;
    } catch (error) {
        if (error.response && error.response.data && error.response.data.error) {
                // If yes, use that message (e.g., "Payment is already in place")
                return rejectWithValue(error.response.data.error);
            }
            // Otherwise, fall back to the generic error message
            return rejectWithValue(error.message);
    }
  }
);



const ordersSlice = createSlice({
  name: 'orders',
  initialState: {
    loading: false,
    isSearching: false, // Added to distinguish between regular fetch and search
    error: null,
    data: [],
    currentOrder: null,  // Add this for single order details
    statusUpdateLoading: false,

     deleteLoading: false,
    deleteError: null,
  },
  reducers: {
     clearDeleteError: (state) => {
      state.deleteError = null;
    }
  },
  extraReducers: (builder) => {
    builder

      .addCase(fetchOrders.pending, (state) => {
        state.loading = true;
        state.isSearching = false;
        state.error = null;
      })
      .addCase(fetchOrders.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchOrders.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Search and filter cases
      .addCase(searchAndFilterOrdersAdmin.pending, (state) => {
        state.loading = true;
        state.isSearching = true;
        state.error = null;
      })
      .addCase(searchAndFilterOrdersAdmin.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(searchAndFilterOrdersAdmin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchOrderDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOrderDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.currentOrder = action.payload;
      })
      .addCase(fetchOrderDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateOrderStatusAdmin.pending, (state) => {
        state.statusUpdateLoading = true;
        state.error = null;
      })
      .addCase(updateOrderStatusAdmin.fulfilled, (state, action) => {
        state.statusUpdateLoading = false;
        if (state.currentOrder) {
          state.currentOrder.status = action.payload.status;
          state.currentOrder.updated_at = action.payload.updated_at;
        }
      })
      .addCase(updateOrderStatusAdmin.rejected, (state, action) => {
        state.statusUpdateLoading = false;
        state.error = action.payload;
      })
      .addCase(deleteOrdersAdmin.pending, (state) => {
        state.deleteLoading = true;
        state.deleteError = null;
      })
      .addCase(deleteOrdersAdmin.fulfilled, (state, action) => {
        state.deleteLoading = false;
        // The backend responds with the UIDs of deleted orders
        const deletedUids = action.payload.order_uids || [];
        // Filter the deleted orders out of the state
        state.data = state.data.filter(order => !deletedUids.includes(order.order_uid));
      })
      .addCase(deleteOrdersAdmin.rejected, (state, action) => {
        state.deleteLoading = false;
        state.deleteError = action.payload;
      });
  }
});
export const { clearDeleteError } = ordersSlice.actions;
export default ordersSlice.reducer;